<h1 mat-dialog-title>Are you sure you wish to create a new departure?</h1>
<div mat-dialog-actions align="end">
  <button [mat-dialog-close]="true" color="primary" mat-button aria-label="Undo">
    <span>CANCEL</span>
  </button>

  <button
    [mat-dialog-close]="true"
    (click)="create()"
    color="primary"
    mat-raised-button
    aria-label="Confirm and continue"
  >
    <span>CONFIRM</span>
  </button>
</div>
